/**
 * @generated SignedSource<<2e9ba31747a1e76bae940ef1508e572c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTrackExposedReturns_viewer$data = {
  readonly user?: {
    readonly isVerifiedTrade: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useEuEligible_viewer">;
  readonly " $fragmentType": "useTrackExposedReturns_viewer";
};
export type useTrackExposedReturns_viewer$key = {
  readonly " $data"?: useTrackExposedReturns_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTrackExposedReturns_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTrackExposedReturns_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useEuEligible_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isVerifiedTrade",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f644604a26911deb0c8f3e2f832481ab";

export default node;
